class BaseModel {
    constructor(model) {
        this.id = model && model.id || null;
    }
}

BaseModel.class = "BaseModel";
export default BaseModel;
